import React from 'react'
import PropTypes from 'prop-types'
import './content-list1.css'

const ContentList1 = ({ heading2, content2, heading3, content3, heading4, content4, heading5, content5, heading6, content6 }) => {
  const renderListItem = (heading, content, defaultHeading, defaultContent) => (
    <li className="list-item">
      <h3 className="thq-heading-3">
        {heading || defaultHeading}
      </h3>
      <p className="thq-body-small">
        {content || defaultContent}
      </p>
    </li>
  )

  return (
    <div className="content-list1-container thq-section-padding">
      <div className="content-list1-max-width thq-section-max-width">
        <div className="content-list1-content thq-flex-column">
          <ul className="content-list1-ul thq-flex-column">
            {renderListItem(
              heading2,
              content2,
              <h3 className="content-list1-text32">Working Group on Research and Innovation</h3>,
              <p className="content-list1-text11"style={{ textAlign: 'justify', display: 'block' }}>
                The Working Group on Research and Innovation is dedicated to advancing AI research and fostering innovation across the Commonwealth. This group is composed of key stakeholders including:
                <br /><br />
                - Government of The Gambia: Abdoulie Jameeh<br />
                - Commonwealth Secretariat: Dr. Radika Kumar<br />
              </p>
            )}
            {renderListItem(
              heading3,
              content3,
              <h3 className="content-list1-text44">Working Group on Policy Development</h3>,
              <p className="content-list1-text45"style={{ textAlign: 'justify', display: 'block' }}>
                The Working Group on Policy Development focuses on creating comprehensive AI policies that support ethical and sustainable AI practices. This group includes representatives from various sectors:
                <br /><br />
                - Government of Rwanda: Esther Kunda and Isabella Umugwaneza<br />
                - HAAS Berkeley: Prof. Solomon Darwin<br />
                - Commonwealth Secretariat: Raj Nair
              </p>
            )}
            {renderListItem(
              heading4,
              content4,
              <h3 className="content-list1-text33"style={{ textAlign: 'justify', display: 'block' }}>Working Group on Capacity Building</h3>,
              <p className="content-list1-text34">
                The Working Group on Capacity Building aims to enhance AI capabilities within the Commonwealth by providing training and resources. This group consists of:
                <br /><br />
                - Government of Bangladesh: Mohamed Zaman<br />
                - Parliament Health: Prof. Rajendra Pratap Gupta<br />
                - Commonwealth Secretariat: Osmal Wood
              </p>
            )}
            {renderListItem(
              heading5,
              content5,
              <h3 className="content-list1-text31"style={{ textAlign: 'justify', display: 'block' }}>Working Group on Data and Infrastructure</h3>,
              <p className="content-list1-text20">
                The Working Group on Data and Infrastructure focuses on developing the necessary data frameworks and infrastructure to support AI initiatives. Members of this group include:
                <br /><br />
                - Government of Malta: André Xuereb<br />
                - NVIDIA: Shilpa Kolhatkar<br />
                - Commonwealth Secretariat: Osmal Wood<br />
              </p>
            )}
            
          </ul>
        </div>
      </div>
    </div>
  )
}

ContentList1.propTypes = {
  heading2: PropTypes.element,
  content2: PropTypes.element,
  heading3: PropTypes.element,
  content3: PropTypes.element,
  heading4: PropTypes.element,
  content4: PropTypes.element,
  heading5: PropTypes.element,
  content5: PropTypes.element,
  heading6: PropTypes.element,
  content6: PropTypes.element,
}

export default ContentList1
